/**
 * Created by hinrich on 12.02.16.
 */

const seeing = () => {
    var _brightBalls = document.getElementsByClassName('bright-ball')
    var _hourRows = document.getElementsByClassName('hour-row')
    var limits = {
        lowest: {
            day: _hourRows[0].getAttribute('data-day') || _hourRows[1].getAttribute('data-day'),
            hour: _hourRows[0].getAttribute('data-hour') || _hourRows[1].getAttribute('data-hour')
        },
        highest: {
            day: _hourRows[_hourRows.length - 1].getAttribute('data-day'),
            hour: _hourRows[_hourRows.length - 1].getAttribute('data-hour')
        }
    }

    var alignSunMoon = function () {
        var offset = _hourRows[0].getBoundingClientRect().top

        for (var i = 0; i < _brightBalls.length; ++i) {
            var brightBall = _brightBalls[i]

            // calculate top
            var time = brightBall.getAttribute('data-rise-time').split(':')
            var bRise = {
                day: brightBall.getAttribute('data-rise-day'),
                hour: parseInt(time[0], 10),
                minute: parseInt(time[1], 10)
            }
            if (!isNaN(bRise.day) && !isNaN(bRise.hour) && bRise.day <= limits.highest.day && !(bRise.day == limits.highest.day && bRise.hour > limits.highest.hour)) {
                var rowTop = findRow(bRise.day, bRise.hour)
                if (rowTop) {
                    var riseRect = rowTop.getBoundingClientRect()
                    var offsetRise = riseRect.height * bRise.minute / 60
                    if (bRise.hour < rowTop.getAttribute('data-hour') || bRise.day < rowTop.getAttribute('data-day')) {
                        var _rises = brightBall.querySelectorAll('.ball-rise')
                        if (0 < _rises.length) {
                            brightBall.removeChild(_rises[0])
                        }
                        offsetRise = 0
                    }
                    brightBall.style.top = Math.floor(riseRect.top + offsetRise - offset) + 'px'
                }
            } else {
                brightBall.parentNode.removeChild(brightBall)
                i--
                continue
            }

            // calculate bottom
            time = brightBall.getAttribute('data-set-time').split(':')
            var bSet = {
                day: brightBall.getAttribute('data-set-day'),
                hour: parseInt(time[0], 10),
                minute: parseInt(time[1], 10)
            }
            if (!isNaN(bSet.day) && !isNaN(bSet.hour) && bSet.day >= limits.lowest.day && !(bSet.day == limits.lowest.day && bSet.hour < limits.lowest.hour)) {
                var rowBottom = findRow(bSet.day, bSet.hour)
                if (rowBottom) {
                    var setRect = rowBottom.getBoundingClientRect()
                    var offsetSet = setRect.height * bSet.minute / 60
                    if (bSet.hour > rowBottom.getAttribute('data-hour') || bSet.day > rowBottom.getAttribute('data-day')) {
                        var _sets = brightBall.querySelectorAll('.ball-set')
                        if (0 < _sets.length) {
                            brightBall.removeChild(_sets[0])
                        }
                        offsetSet = setRect.height
                    }
                    brightBall.style.height = Math.floor(setRect.top + offsetSet - parseInt(brightBall.style.top, 10) - offset) + 'px'

                }
            } else {
                brightBall.parentNode.removeChild(brightBall)
                i--
                continue
            }

            // remove info if height is limited
            removeMetaData(brightBall, ['.illumination', '.moon-icon'])
            var ballMeta = brightBall.querySelectorAll('.ball-meta')[0]
            ballMeta.style.marginTop = (-0.5 * ballMeta.getBoundingClientRect().height) + 'px'

            if (brightBall.classList) {
                brightBall.classList.remove('invisible')
            } else {
                brightBall = el.className.replace('invisible', '')
            }
        }
    }

    function removeMetaData(parentNode, items) {
        if ('object' !== typeof items || 0 >= items.length) {
            return
        }
        var children = parentNode.childNodes
        var heightChildren = 0
        for (var i = 0; i < children.length; ++i) {
            var child = children[i]
            if ('getBoundingClientRect' in child) {
                heightChildren += children[i].getBoundingClientRect().height
            }
        }

        if (parentNode.getBoundingClientRect().height < heightChildren) {
            var victims = parentNode.querySelectorAll(items.shift())
            if (0 < victims.length) {
                victims[0].parentNode.removeChild(victims[0])
            }
            removeMetaData(parentNode, items)
        }
    }

    function findRow(day, hour) {
        if (day < limits.lowest.day || (day == limits.lowest.day && hour <= limits.lowest.hour)) {
            return _hourRows[0]
        }
        if (day > limits.highest.day || (day == limits.highest.day && hour >= limits.highest.hour)) {
            return _hourRows[_hourRows.length - 1]
        }

        for (var i = 0; i < _hourRows.length; ++i) {
            var hourRow = _hourRows[i]

            var d = hourRow.getAttribute('data-day')
            var h = hourRow.getAttribute('data-hour')

            if (day == d && hour == h) {
                return hourRow
            }
        }

        return false
    }

    return {
        alignSunMoon: alignSunMoon
    }
}


window.addEventListener('load', function loadSeeing() {
    window.removeEventListener('load', loadSeeing, false)

    const s = seeing()
    try {
        s.alignSunMoon()
    } catch(e) {
        if(window.console) {
            console.warn(e)
        }
    }

    window.addEventListener('resize', function resize() {
        s.alignSunMoon()
    })
}, false)